var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.7,87.3c128.5,0,232.7,104.2,232.7,232.7s-104.2,232.7-232.7,232.7-149-39.4-191-99.8c-12.2-17.6-36.5-21.8-54.1-9.6-17.6,12.2-21.8,36.5-9.6,54.1,56,80.2,149.2,132.8,254.7,132.8,171.4,0,310.3-138.9,310.3-310.3S501.1,9.7,329.7,9.7,133.9,60.7,77.6,139v-32.4c0-21.5-17.3-38.8-38.8-38.8S0,85.2,0,106.7v135.8c0,21.5,17.3,38.8,38.8,38.8h135.9c21.5,0,38.8-17.3,38.8-38.8s-17.3-38.8-38.8-38.8h-46.4c40.1-69.6,115.4-116.4,201.5-116.4ZM358.8,193.9c0-16.1-13-29.1-29.1-29.1s-29.1,13-29.1,29.1v126.1c0,7.8,3,15.2,8.5,20.6l87.3,87.3c11.4,11.4,29.8,11.4,41.1,0,11.3-11.4,11.4-29.8,0-41.1l-78.8-78.8v-114.1h.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.2f10ea984d564c7432c757ee25f65321.svg";
export { ForwardRef as ReactComponent };